export const PRIVACY_POLICY_URL = "https://www.shuttlerock.com/privacy";
